import { useState } from "react";
import { toast } from "sonner";
import { Sprout } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Save a line to "Things you said helped" in the playbook
export const HelpedQuoteButton = ({ text, source, testId, className = "" }) => {
  const [saved, setSaved] = useState(false);
  const save = async () => {
    try { await api.post("/playbook/quotes", { text: text.slice(0, 500), source }); setSaved(true); toast.success("Saved to What Helps Me 🌱"); }
    catch (e) { toast.error(errMsg(e, "Could not save")); }
  };
  return (
    <button type="button" onClick={save} disabled={saved} className={`inline-flex items-center gap-1 text-xs font-semibold text-mm-primary hover:underline disabled:opacity-60 disabled:no-underline ${className}`} data-testid={testId}>
      <Sprout size={13} />{saved ? "In your playbook" : "This helped"}
    </button>
  );
};
